import React, { useCallback, useEffect, useMemo, useState } from 'react';

import chevronUp from '../../../assets/icons/chevron-up.svg';
import chevronDown from '../../../assets/icons/chevron-down.svg';
import chevronLeft from '../../../assets/icons/chevron-left.svg';
import chevronRight from '../../../assets/icons/chevron-right.svg';

import {
  Container,
  TakeContainer,
  TakeSelector,
  TakeDropdown,
  TakeButton,
  PaginationInfo,
  Paginator,
} from './Pagination.styles';
import { PaginationProps } from './Pagination.types';

const Pagination: React.FC<PaginationProps> = ({
  style,
  numElements,
  take = 5,
  updateTake,
  currentPage = 1,
  updateCurrentPage,
}) => {
  const [openTakeDropdown, setOpenTakeDropdown] = useState(false);

  const numPages = useMemo(() => Math.ceil(numElements / take), [numElements, take]);

  const handlePageChange = useCallback(
    (direction: 'left' | 'right') => {
      if (direction === 'right') {
        currentPage < numPages && updateCurrentPage(page => page + 1);
        return;
      }
      currentPage > 1 && updateCurrentPage(page => page - 1);
    },
    [currentPage, numPages, updateCurrentPage],
  );

  const handleTakeChange = useCallback(
    number => {
      updateTake(number);
      setOpenTakeDropdown(false);
    },
    [updateTake],
  );

  useEffect(() => {
    if (currentPage > numPages) {
      updateCurrentPage(1);
    }
  }, [currentPage, numPages, updateCurrentPage]);

  return (
    <Container data-testid="pagination" style={style}>
      <TakeContainer>Itens por página: </TakeContainer>
      <div style={{ width: '24px' }} />
      <TakeSelector
        onMouseEnter={() => setOpenTakeDropdown(true)}
        onMouseLeave={() => setOpenTakeDropdown(false)}
      >
        {take}
        <div style={{ width: '5px' }} />
        {openTakeDropdown ? <img src={chevronUp} /> : <img src={chevronDown} />}
        {openTakeDropdown && (
          <TakeDropdown>
            {[5, 10, 15, 20]
              .filter(number => number !== take)
              .map(number => (
                <TakeButton key={number} onClick={() => handleTakeChange(number)}>
                  {number}
                </TakeButton>
              ))}
          </TakeDropdown>
        )}
      </TakeSelector>
      <div style={{ width: '24px' }} />
      <PaginationInfo>
        {currentPage}-{numPages} de {numElements}
      </PaginationInfo>
      <div style={{ width: '24px' }} />
      <Paginator>
        <img src={chevronLeft} onClick={() => handlePageChange('left')} alt="chevron-left" />
        <img src={chevronRight} onClick={() => handlePageChange('right')} alt="chevron-right" />
      </Paginator>
      <div style={{ width: '16px' }} />
    </Container>
  );
};

export default Pagination;
